import type { JSX } from 'react';

import { cn } from '@change/ds-utils';

import { Avatar } from '@change/ds-core-ui/next';

import { useGetPictures } from './hooks/useGetPictures';

export function Pictures(): JSX.Element {
	const {
		data: { pictures },
	} = useGetPictures();

	return (
		<div className="flex justify-center gap-2">
			{pictures.map((picture, idx) => {
				return (
					<div
						className={cn('relative h-10 w-10', picture.desktopOnly ? 'hidden md:inline-block' : '')}
						// eslint-disable-next-line react/no-array-index-key
						key={`taking-action-picture-${idx}`}
					>
						<Avatar alt="avatar" size="medium" src={picture.url} className="z-0 grayscale" />
						<div className="bg-fill-accent-primary-strong absolute inset-0 h-full w-full rounded-full opacity-15" />
					</div>
				);
			})}
		</div>
	);
}
